export default __webpack_public_path__ + "static/h1company_sp-c5a1d205268405e1825ddba9e024858d.png";